module.exports = __webpack_public_path__ + "img/btn_2_hover.198dc4be.png";